/* eslint-disable no-use-before-define */
import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Paper } from '@material-ui/core';
import { usePageContext } from '../../context/PageContext';
import { lazySystemCode } from '../../services/CommonService';
import color from '../../assets/css/colors';
import fontFamily from '../../assets/css/fonts';

const useStyles = makeStyles(() => ({
  autocompleteWrapper: {
    '& .MuiAutocomplete-inputRoot': {
      padding: '7px 50px 8px 15px !important',
    },
    '& .MuiAutocomplete-option': {
      backgroundColor: 'red',
    },
    '& .MuiAutocomplete-endAdornment': {
      top: 'calc(50% - 15px)',
      '& svg': {
        width: '22px !important',
        height: '22px !important',
      },
    },
  },
  paper: {
    fontFamily: fontFamily.label,
    fontSize: 15,
    fontWeight: 600,
    backgroundColor: color.light.main,
  },
}));

function SelectAutoCompleteSystemCode(props) {
  const { customFieldName } = usePageContext();
  const label = customFieldName(props.label);
  const classes = useStyles();
  const [options, setOptions] = React.useState([]);

  React.useEffect(() => {
    if (options.length === 0) {
      getOptions(props);
    }
    // eslint-disable-next-line
  }, [props]);

  const getOptions = async (data) => {
    const { systemCodeList } = await lazySystemCode({
      type: props.type,
      subType: props.subType,
      code: data.value,
      note: props.note,
      limit: props.limit,
      multiple: true,
    });

    const list = systemCodeList.filter((s) => s.code);
    const nonTrade = { code: 'NON TRD', description: 'Non Trade Entry' };

    if (props.type === 'Entry Type') {
      list.push(nonTrade);
    }

    setOptions(list);
  };

  const setPropsValue = (value) => {
    props.onChange({
      currentTarget: {
        name: props.name,
        value: value,
      },
      target: {
        name: props.name,
        value: value,
      },
    });
  };

  return (
    <div className={classes.root}>
      <Autocomplete
        multiple
        //freeSolo={true}
        disabled={props.disabled}
        options={options}
        getOptionLabel={(option) => {
          console.log('option', option);
          let description = option?.description;
          let code = option?.code;
          // get by system ref
          if (option.type === 'Margin Type') {
            const res = options.find((v) => {
              return v.systemRef === option?.systemRef?.trim();
            });
            code = res?.code;
            description = res?.description;
          } else if (!description && props.type !== 'Margin Type') {
            const res = options.find((v) => {
              return v.code === code.trim();
            });
            description = res?.description ? res?.description : 'loading...';
          }
          return [
            'Status',
            'Side',
            'System Process',
            'Broker',
            'Legal Entity',
            'Margin Type',
            'Call Type',
          ].includes(props.type) || props.subType === 'Internal Status'
            ? code?.trim()
            : ['Sub Account No'].includes(props.type)
            ? description
            : code?.trim() + ' - ' + description;
        }}
        getOptionSelected={(option, value) => option.code === value.code}
        onChange={(e, value) => {
          setPropsValue(value);
        }}
        onKeyDown={props.onKeyDown}
        value={props.value}
        PaperComponent={({ children }) => (
          <Paper className={classes.paper}>{children}</Paper>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            name={props.name}
            required={props.required}
            disabled={props.disabled}
            label={(props?.prefixLabel ? props?.prefixLabel : '') + label}
            InputLabelProps={{ shrink: true }}
          />
        )}
      />
    </div>
  );
}

export const SelectMarginType = (props) => {
  return <SelectAutoCompleteSystemCode {...props} type={'Margin Type'} />;
};

export const SelectStatus = (props) => {
  return (
    <SelectAutoCompleteSystemCode {...props} type={props.type} subType={props.subType} />
  );
};

export const SelectSide = (props) => {
  return (
    <SelectAutoCompleteSystemCode {...props} type={props.type} subType={props.subType} />
  );
};

export const SelectCallType = (props) => {
  return <SelectAutoCompleteSystemCode {...props} type={'Call Type'} />;
};
